import { SharedIconsModule } from '../../icons/shared-icons.module';
import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Toast, ToastService, ToastType } from './toast.service';

const DEFAULT_TITLES: Record<ToastType, string> = {
  [ToastType.Success]: 'Success',
  [ToastType.Error]: 'Something went wrong',
  [ToastType.Warning]: 'Warning',
  [ToastType.Info]: 'Info',
};

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [SharedIconsModule, AsyncPipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  protected readonly ToastType = ToastType;

  private readonly toastService = inject(ToastService);
  toasts$ = this.toastService.toasts$;

  titleOf(toast: Toast): string {
    return toast.title ?? DEFAULT_TITLES[toast.type];
  }

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  pause(id: string): void {
    this.toastService.pause(id);
  }

  resume(id: string): void {
    this.toastService.resume(id);
  }
}
